var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "payment_splits",
          route_grid_path: "/grid",
          order_column: "created_at",
          direction: "desc",
          hide_actions: "true",
          "show-export": true,
          "export-types": ["csv", "xls"],
          "export-filename": "hubee_payment_splits",
          "fetch-on-mounted": false,
          hide_searchbar: "true",
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function () {
              return [
                _c("FinancialPeriodFilter", {
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID Split"),
                ]),
                _c(
                  "vs-th",
                  { key: "payment_id", attrs: { "sort-key": "payment_id" } },
                  [_vm._v("ID Pagamento")]
                ),
                _c(
                  "vs-th",
                  { key: "split_to", attrs: { "sort-key": "split_to" } },
                  [_vm._v("Tipo")]
                ),
                _c("vs-th", { key: "recipient_name" }, [_vm._v("Recebedor")]),
                _c(
                  "vs-th",
                  {
                    key: "amount_total",
                    attrs: { "sort-key": "amount_total" },
                  },
                  [_vm._v("Valor Total")]
                ),
                _c("vs-th", { key: "value", attrs: { "sort-key": "value" } }, [
                  _vm._v("Valor"),
                ]),
                _c(
                  "vs-th",
                  { key: "created_at", attrs: { "sort-key": "created_at" } },
                  [_vm._v("Data")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.id))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "payment_id", attrs: { width: "10%" } },
                      [_c("div", [_vm._v(_vm._s(tr.payment_id))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "split_to", attrs: { width: "10%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: { color: _vm.getSplitToColor(tr.split_to) },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getSplitToLabel(tr.split_to)) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "recipient_name", attrs: { width: "30%" } },
                      [
                        _c(
                          "div",
                          [
                            _vm._v(" " + _vm._s(tr.recipient_name) + " "),
                            tr.is_platform_fee
                              ? _c(
                                  "vs-chip",
                                  {
                                    staticClass: "text-sm ml-1",
                                    attrs: { color: "warning" },
                                  },
                                  [
                                    _vm._v(
                                      " Taxa da plataforma" +
                                        _vm._s(
                                          tr.applied_fee_percent
                                            ? " (" +
                                                tr.applied_fee_percent +
                                                "%)"
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "amount_total", attrs: { width: "10%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatCurrency(tr.amount_total))),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "value", attrs: { width: "15%" } }, [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v(_vm._s(_vm.formatCurrency(tr.value))),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "created_at", attrs: { width: "20%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$utils.format.date(tr.created_at))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }